/** Shared order-status badge palette — identical to the admin dashboard. */
export const ORDER_STATUS_BADGE: Record<string, string> = {
  pending: "bg-orange-500/15 text-orange-600 border border-orange-500/50",
  confirmed: "bg-primary/15 text-primary border border-primary/40",
  shipped: "bg-success/15 text-success border border-success/40",
  delivered: "bg-success text-success-foreground border border-success",
  returned: "bg-amber-500/30 text-amber-900 border border-amber-700/60",
  cancelled: "bg-destructive/15 text-destructive border border-destructive/40",
};

export function orderStatusBadge(status?: string | null) {
  const key = String(status ?? "").toLowerCase();
  return (
    ORDER_STATUS_BADGE[key] ??
    "bg-surface-container text-on-surface border border-outline-variant/40"
  );
}
